import { useEffect, useState } from 'react';

const getOnLineStatus = (): boolean =>
  typeof navigator !== 'undefined' ? navigator.onLine : true;

const useNavigatorOnline = (): boolean => {
  const [status, setStatus] = useState(getOnLineStatus());

  const setOnline = (): void => setStatus(true);
  const setOffline = (): void => setStatus(false);

  useEffect(() => {
    window.addEventListener('online', setOnline);
    window.addEventListener('offline', setOffline);

    return () => {
      window.removeEventListener('online', setOnline);
      window.removeEventListener('offline', setOffline);
    };
  }, []);

  return status;
};

export default useNavigatorOnline;
